import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, MailIcon, MapPinIcon, CalendarIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="relative py-20 md:py-32 bg-gradient-to-br from-brand-teal-dark to-brand-navy overflow-hidden" data-id="element-64">
      {/* Background Glows */}
      <div className="absolute top-0 left-0 w-full h-full bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjIiIGZpbGw9InJnYmEoMjU1LDI1NSwyNTUsMC4wNSkiLz48L3N2Zz4=')] opacity-20" data-id="element-65"></div>
      <div className="absolute -bottom-40 -right-40 w-96 h-96 bg-brand-laser-red/20 rounded-full blur-[100px] pointer-events-none" data-id="element-66"></div>

      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-67">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-68">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-69">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-70">
              Why Block the Pain When You Can{' '}
              <span className="text-teal-300" data-id="element-71">Treat the Problem?</span>
            </h2>
            <p className="text-xl text-teal-50 mb-10 leading-relaxed" data-id="element-72">
              Take the first step toward recovery with safe, non-invasive,
              drug-free laser therapy. Support your body's natural healing
              process and get back to moving freely.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-12" data-id="element-73">
              <button className="px-8 py-4 bg-white hover:bg-gray-50 text-brand-teal rounded-lg font-bold text-lg transition-all duration-300 flex items-center justify-center gap-2 shadow-xl" data-id="element-74">
                <CalendarIcon className="w-5 h-5" data-id="element-75" />
                Schedule a Consultation
              </button>
              <button className="px-8 py-4 bg-transparent hover:bg-white/10 text-white border-2 border-white/30 rounded-lg font-bold text-lg transition-all duration-300 flex items-center justify-center gap-2" data-id="element-76">
                <PhoneIcon className="w-5 h-5" data-id="element-77" />
                Call Now
              </button>
            </div>

            <div className="space-y-6 text-teal-100" data-id="element-78">
              <div className="flex items-center gap-4" data-id="element-79">
                <div className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-80">
                  <PhoneIcon className="w-5 h-5" data-id="element-81" />
                </div>
                <div data-id="element-82">
                  <p className="text-sm text-teal-200/70 uppercase tracking-wider font-bold" data-id="element-83">
                    Call Us
                  </p>
                  <p className="text-lg font-medium" data-id="element-84">(555) 123-4567</p>
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-85">
                <div className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-86">
                  <MailIcon className="w-5 h-5" data-id="element-87" />
                </div>
                <div data-id="element-88">
                  <p className="text-sm text-teal-200/70 uppercase tracking-wider font-bold" data-id="element-89">
                    Email Us
                  </p>
                  <p className="text-lg font-medium" data-id="element-90">
                    hello@aspenlaserclinic.com
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-91">
                <div className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-92">
                  <MapPinIcon className="w-5 h-5" data-id="element-93" />
                </div>
                <div data-id="element-94">
                  <p className="text-sm text-teal-200/70 uppercase tracking-wider font-bold" data-id="element-95">
                    Visit Us
                  </p>
                  <p className="text-lg font-medium" data-id="element-96">
                    123 Healing Way, Suite 100
                    <br data-id="element-97" />
                    Wellness City, ST 12345
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-brand-navy/40 backdrop-blur-md border border-white/10 p-8 rounded-2xl shadow-2xl" data-id="element-98">
            <h3 className="text-2xl font-bold text-white mb-6" data-id="element-99">
              Request an Appointment
            </h3>
            <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-100">
              <div data-id="element-101">
                <label className="block text-sm font-medium text-teal-100 mb-1" data-id="element-102">
                  Full Name
                </label>
                <input type="text" className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white placeholder-teal-100/30 focus:outline-none focus:ring-2 focus:ring-brand-teal focus:border-transparent transition-all" placeholder="John Doe" data-id="element-103" />
              </div>
              <div data-id="element-104">
                <label className="block text-sm font-medium text-teal-100 mb-1" data-id="element-105">
                  Email Address
                </label>
                <input type="email" className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white placeholder-teal-100/30 focus:outline-none focus:ring-2 focus:ring-brand-teal focus:border-transparent transition-all" placeholder="john@example.com" data-id="element-106" />
              </div>
              <div data-id="element-107">
                <label className="block text-sm font-medium text-teal-100 mb-1" data-id="element-108">
                  Phone Number
                </label>
                <input type="tel" className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white placeholder-teal-100/30 focus:outline-none focus:ring-2 focus:ring-brand-teal focus:border-transparent transition-all" placeholder="(555) 000-0000" data-id="element-109" />
              </div>
              <div data-id="element-110">
                <label className="block text-sm font-medium text-teal-100 mb-1" data-id="element-111">
                  Message / Condition
                </label>
                <textarea rows={4} className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white placeholder-teal-100/30 focus:outline-none focus:ring-2 focus:ring-brand-teal focus:border-transparent transition-all resize-none" placeholder="Tell us briefly what you'd like to treat..." data-id="element-112"></textarea>
              </div>
              <button className="w-full px-8 py-4 bg-brand-teal hover:bg-brand-teal-dark text-white rounded-lg font-bold text-lg transition-all duration-300 mt-4 shadow-lg shadow-brand-teal/25" data-id="element-113">
                Send Request
              </button>
            </form>
          </motion.div>
        </div>

        {/* Optional Promo Strip */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-20 border-t border-white/10 pt-10 flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-teal-200/60 font-medium uppercase tracking-wider" data-id="element-114">
          <span data-id="element-115">Ask About Discovery Day</span>
          <span className="hidden md:inline" data-id="element-116">•</span>
          <span data-id="element-117">Package Plans Available</span>
          <span className="hidden md:inline" data-id="element-118">•</span>
          <span data-id="element-119">Gift Certificates</span>
          <span className="hidden md:inline" data-id="element-120">•</span>
          <span data-id="element-121">Wellness Follow-Ups</span>
        </motion.div>
      </div>
    </section>;
}